
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { ClientType } from '../../../enums/ClientType';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import { useNavigate } from 'react-router-dom';

import {
    workflowDataService,
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    CustomAutoComplete,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions
} from '../../../components/ComponentsLibrary';


const WorkflowActivities = forwardRef((props, ref) => {

    const {
        onComponentMount = () => { },
        PrimaryID,
        noCase,
        caseWorkflowID = null
    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadWorkflowActivitiesByCaseID,
    }));

    useEffect(() => {
        if (onComponentMount) {
            onComponentMount();
        }
    }, []);

    const errorFormName = "Case Detail - Workflow Activities";
    const navigate = useNavigate();

    let currentActivePage = Number(SessionManager.GetValueFromSession("CurrentActivePageKey"));
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    // const { siteID, timeZone } = SessionManager.GetDataFromSession("LoginUserInfoKey") || {};

    const loginUserInfo = sessionService.getUser();
    const { siteID, stateID, timeZone } = loginUserInfo || {};

    const caseDocsDataRefs = useRef([]); // Store DataGrid data persistently
    const pdfViewerRef = useRef(null);

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [resultsWorkflowActivity, setResultsWorkflowActivity] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const [enableShowExternalDocument, setEnableShowExternalDocument] = useState(false);
    const [uncExternalDocumentUrl, setUncExternalDocumentUrl] = useState('');

    const [workflowStatusOptions, setWorkflowStatusOptions] = useState([]);
    const [workflowTypeSelected, setWorkflowTypeSelected] = useState('OpenAndCompletedWorkflows');

    const defaultPermissionsForFields = {
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        workflowActivityDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);


    const customDateFormat = "MM/DD/YYYY hh:mm:ss A";
    const customTimeFormat = "HH:mm:ss";
    const nextStepDueTSFormat = "MM/DD/YYYY";
    
    // Grid Columns: Test Data Documents for a Case Number
    const workflowActivityGridColumns = [
        { field: 'relatedActivityID', headerName: 'QA Related', minWidth: 100, renderCell: (params) => params.value > 0 ? <span style={{ color: 'black', fontSize: '1.5em', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>&#10003;</span>: null},
        { field: 'workflowName', headerName: 'Workflow', minWidth: 120 },
        { field: 'departmentName', headerName: 'Queue', minWidth: 150 },
        { field: 'createdTS', headerName: 'Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 200 },
        { field: 'contactID', headerName: 'Y-Trac Contact ID', valueFormatter: (value) => value === 0 ? '' : value, minWidth: 150 },
        { field: 'workflowActionTypeReportName', headerName: 'Action Taken', minWidth: 300 },
        { field: 'userName', headerName: 'Action By', minWidth: 150 },
        { field: 'workTime', headerName: 'Task Work Time', minWidth: 140 },
        { field: 'nextWorkflowName', headerName: 'Next Action Workflow', minWidth: 180 },
        { field: 'nextDepartmentName', headerName: 'Next Action Queue', minWidth: 160 },
        { field: 'nextWorkflowStepName', headerName: 'Next Action Type', minWidth: 300 },
        {
            field: 'nextStepDueTS', headerName: 'Next Action Due', type: 'date', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, nextStepDueTSFormat), minWidth: 200
        },
        { field: 'activityNoteContent', headerName: 'Trac Note', minWidth: 300 },
        { field: 'narrativeContent', headerName: 'Narrative', minWidth: 500 },
    ];


    // Grid Columns: Test Data Documents for a Case Number
    const workflowActivityGridColumns02 = [
        { field: 'qaRelated', headerName: 'QA Related', flex: 1 },
        { field: 'workflow', headerName: 'Workflow', flex: 1 },
        { field: 'queue', headerName: 'Queue', flex: 1 },
        { field: 'date', headerName: 'Date', flex: 1 },
        { field: 'yTracContactID', headerName: 'Y-Trac Contact ID', valueFormatter: (value) => value === 0 ? '' : value, flex: 1 },
        { field: 'actionTaken', headerName: 'Action Taken', flex: 1 },       
    ];
    const workflowActivityGridRows = [
        { id: 1, qaRelated: '', workflow: 'Documents', queue: 'Doc-C (Locate)', date: '8/16/2024', yTracContactID: '', actionTaken: 'Worked Doc-Clear Locate Form', },
        { id: 2, qaRelated: '', workflow: 'Establishment-Locate', queue: 'Est-Locate-Add', date: '7/28/2024', yTracContactID: '', actionTaken: 'Added WF-Establishment-Locate', },
        { id: 3, qaRelated: '', workflow: 'Intake', queue: 'Intake-Add', date: '4/08/2024', yTracContactID: '', actionTaken: 'Added WF-Intake', },
        { id: 4, qaRelated: '', workflow: 'Documents', queue: 'Doc-A (General)', date: '7/12/2024', yTracContactID: '', actionTaken: 'Generic-Auto-Ended', },
    ];




    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const onLoadWorkflowActivitiesByCaseID = async (populateDropdown = false, completed = null, thisWorkflowSelect = false) => {
        try {
           // console.log("calling onLoadWorkflowActivitiesByCaseID", populateDropdown, completed);
            const caseID = PrimaryID;
            let paramsObj = {};
            let workflowActivityApiData = [];

            if(!noCase) {
                paramsObj = {
                    caseNumber: caseID,
                    YTracSiteID: siteID,
                    recCount: 0,
                    masterServerDBSchema,
                    caseWorkflowID: thisWorkflowSelect? caseWorkflowID: null,// to fetch this workflow only or multiple records 
                    completed,
                    systemTimeZoneName: timeZone
                };//TODO caseworkflow id hardcoded

                workflowActivityApiData = await workflowDataService.getWorkflowActivityFromApiByCaseID(paramsObj);
            } else {
                paramsObj = {
                    masterServerDBSchema,
                    caseWorkflowID: caseID,
                    YTracSiteID: siteID,
                    systemTimeZoneName: timeZone
                };

                workflowActivityApiData = await workflowDataService.getNoCaseWorkflowActivityFromApi(paramsObj);
            };

            const normalizedActivityData = Array.isArray(workflowActivityApiData) ? workflowActivityApiData : [];
            const rowsWithIds = normalizedActivityData.map((item, index) => ({ ...item, id: index }));
            setResultsWorkflowActivity(rowsWithIds);
            if (populateDropdown) {
                const params = {
                    DropdownCategoryTypeID: currentActivePage
                };
                const apiWfStatusOptions = await workflowDataService.getWorkflowStatusOptions(params);
                const dropdownOptions = apiWfStatusOptions.map((option, idx) => ({
                    "id": idx,
                    "label": option.dropdownTypeName,
                    "value": option.dropdownTypeID
                }));
                setWorkflowStatusOptions(dropdownOptions);
                // set open and closed by default
                if (currentActivePage === ClientType.DropdownCategoryType.NewWorkItem) {
                    setWorkflowTypeSelected(ClientType.DropDownType.Add__All_Open_And_Closed_Workflows);
                }
                else if(currentActivePage === ClientType.DropdownCategoryType.Case_View) {
                    setWorkflowTypeSelected(ClientType.DropDownType.Case_View__All_Open_And_Closed_Workflows);
                }
                 else if (currentActivePage === ClientType.DropdownCategoryType.NextWorkItem) {
                    setWorkflowTypeSelected(ClientType.DropDownType.Work__All_Open_And_Closed_Workflows);
                }
                else if ( ClientType.DropdownCategoryType.Action_Taken_Details) {
                   setWorkflowTypeSelected(ClientType.DropDownType.Action_Taken__All_Open_And_Closed_Workflows)
                }
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadWorkflowActivitiesByCaseID");
        }
    };

    const handleWorkflowTypeChange = (e, newValue, reason) => {
        //const { name, value } = e.target;
        setWorkflowTypeSelected(newValue.value);
        let completed = null;
        if ([ClientType.DropDownType.Work__All_Open_Workflows,
            ClientType.DropDownType.Add__All_Open_Workflows,
            ClientType.DropDownType.Case_View__All_Open_Workflows,
            ClientType.DropDownType.Action_Taken__All_Open_Workflows].includes(newValue.value)) {
            completed = false;
        }
        if ([ClientType.DropDownType.Work__This_Workflow_Only, ClientType.DropDownType.Action_Taken__This_Workflow_Only].includes(newValue.value)) {
            onLoadWorkflowActivitiesByCaseID(false, completed, true);
        }
        else {
            onLoadWorkflowActivitiesByCaseID(false, completed);
        }
        
    };


    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };


    const handleCellDoubleClick = async (params) => {
        if (params.field === "workflowActionTypeReportName") {
            const actionTakenData = await ApiManager.GetActionTakenDetails({activityID: params.row?.activityID, stateID, masterServerDBSchema})
            navigate("/actionTakenDetails", { state: {row:  params.row, actionTakenData: actionTakenData?.[0] } })
        }
    }

    const activeCaseWorkflowID = caseWorkflowID ?? (noCase ? PrimaryID : null);
    const highlightedWorkflowActivityRowID = resultsWorkflowActivity
        .filter((row) => activeCaseWorkflowID != null && String(row.caseWorkflowID) === String(activeCaseWorkflowID))
        .reduce((latestRow, row) => {
            if (!latestRow) return row;

            const latestCreatedTS = new Date(latestRow.createdTS).getTime();
            const rowCreatedTS = new Date(row.createdTS).getTime();

            if (Number.isNaN(rowCreatedTS)) return latestRow;
            if (Number.isNaN(latestCreatedTS) || rowCreatedTS > latestCreatedTS) return row;

            return latestRow;
        }, null)?.id;


    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================



    const mainWorkflowActivityContent = (
        <div style={{ padding: '10px 5px 5px', width: '100%' }}>            {
            resultsWorkflowActivity.length > 0 ? (
                <div>{/* Middle Section - Document Grid and Buttons  */}
                    <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                        <div className="two-column-layout-container-2">
                            <div className="left-column-custom-2 text-wrapper-header-2" style={{ paddingLeft: '10px', }}>Workflow Activities:</div>
                            <div className="right-column-custom-2">
                                {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                    <Button id="clearFiltersBtn" name="clearFiltersBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>CLEAR FILTERS</Button>
                                )}
                                {!(formFieldAccess.workflowTypeSelect?.hide ?? false) && (
                                    <div style={{ width: '70%' }}>
                                        <CustomAutoComplete
                                            customVariant='defaultVariant'
                                            idForControl='workflowTypeSelect'
                                            labelForControl=''
                                            valueForControl={workflowTypeSelected}
                                            onChange={handleWorkflowTypeChange}
                                            optionsSource={workflowStatusOptions}
                                            multiple={false}
                                            disableCloseOnSelect={false}
                                            getOptionLabel={(option) => option?.label || ''}
                                            noOptionsText='Workflow Not Found'
                                        />
                                    </div>


                                )}
                            </div>
                        </div>
                        {!(formFieldAccess.workflowActivityDgrd?.hide ?? false) && (
                            <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                                <DataGridPremium
                                    id="workflowActivityDgrd"
                                    name="workflowActivityDgrd"
                                    rows={resultsWorkflowActivity}
                                    columns={workflowActivityGridColumns}
                                    rowsPerPageOptions={[5]}
                                    pagination
                                    pageSizeOptions={[5, 10, 15, 20, 25]}
                                    paginationModel={paginationModel} // Controlled pagination
                                    onPaginationModelChange={setPaginationModel} // Handle page changes 
                                    filterModel={gridFilterModel}
                                    onFilterModelChange={handleGridFilterChange}
                                    onCellDoubleClick={ handleCellDoubleClick}
                                    getRowClassName={(params) =>
                                        params.id === highlightedWorkflowActivityRowID ? 'current-workflow-activity' : ''
                                    }
                                    autosizeOnMount
                                    autosizeOptions={{
                                        includeHeaders: true,
                                        includeOutliers: true,
                                        expand: true
                                    }}
                                    sx={{
                                        "& .MuiDataGrid-row:hover": {
                                            cursor: "pointer"
                                        },
                                        "& .MuiDataGrid-row.current-workflow-activity": {
                                            backgroundColor: "rgba(25, 118, 210, 0.16)",
                                            "&:hover": {
                                                backgroundColor: "rgba(25, 118, 210, 0.24)"
                                            }
                                        },
                                        ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                            "margin-top": "1em",
                                            "margin-bottom": "1em"
                                        },
                                        "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                    }}
                                />
                            </div>
                        )}
                    </Paper>
                </div>
            )
                :
                <div className="text-wrapper-subtitle">No Workflow Activity found for the Case!</div>
        }
        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainWorkflowActivityContent}
        </div>
    );
});

export default WorkflowActivities;


